import React, { Fragment, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import { validate, validators } from 'validate-redux-form';
import { FormatDate } from '../../../../Utils/renderField/hookForms';
import { NumberField } from '../../../../Utils/renderField/fieldsHookForms';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { renderSwitch } from '../../../../Utils/renderField/renderField';
import { RenderNumber } from '../../../../Utils/renderField/renderReadField';
import { getColorVariacionDRC } from '../../../../Utils/LaboratorioDRC/Common';
import './VariacionDRCForm.css';

/**
 * Componente para el paso de variación de DRC.
 * @param {object} props - Props del componente.
 * @returns {JSX.Element} - Componente de formulario de variación de DRC.
 */
let VariacionDRCForm = props => {
    const { handleSubmit, previousStep } = props;
    const { control, formState: { errors }, watch, reset, trigger } = useForm();

    const renderHistorial = (fieldArrayProps) => {

        const { fields, meta: { error, submitFailed } } = fieldArrayProps;
        const { variacion_drc_solidos, variacion_drc_latex } = watch();

        const AgregarRegistro = async () => {
            const camposValidos = await trigger();
            if (!camposValidos) return;

            const variacion_drc_solidos_float = parseFloat(variacion_drc_solidos.replace(",", ""));
            const variacion_drc_latex_float = parseFloat(variacion_drc_latex.replace(",", ""));

            fields.push({
                variacion_drc_solidos: variacion_drc_solidos_float,
                variacion_drc_latex: variacion_drc_latex_float,
                creado: new Date()
            });

            reset({
                variacion_drc_solidos: '',
                variacion_drc_latex: ''
            });
        }

        const historial = fields.getAll() ? [...fields.getAll()] : [];

        return (
            <div className=" col-sm-12 p-0">
                <div className="d-flex justify-content-center mt-2 mb-3">
                    <button type="button" className="btn btn-outline-info py-0" onClick={AgregarRegistro}>
                        AGREGAR
                    </button>
                </div>

                {historial.length <= 0 ?
                    <div className="d-flex justify-content-center">
                        <p className="text-center">No hay registros de variación de DRC</p>
                    </div>
                    :
                    <Fragment>
                        <h6 className="my-3">HISTORIAL DE CONFIGURACIÓN</h6>

                        <div className="variacion-drc-form__table-wrapper new-table-wrapper">
                            <table className="table mb-0">
                                <thead>
                                    <tr>
                                        <th>FECHA</th>
                                        <th className='th--right'>VARIACIÓN DRC DE SÓLIDOS</th>
                                        <th className='th--right'>VARIACIÓN DRC DE LÁTEX</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {historial.reverse().map((registro, index) => (
                                        <tr key={index}>
                                            <td>
                                                {FormatDate(registro.creado)}
                                            </td>
                                            <td className={`td--right td--no-wrap ${getColorVariacionDRC(registro.variacion_drc_solidos)}`}>
                                                <RenderNumber
                                                    value={registro.variacion_drc_solidos}
                                                    decimalScale={2}
                                                    suffix=" %" />
                                            </td>
                                            <td className={`td--right td--no-wrap ${getColorVariacionDRC(registro.variacion_drc_latex)}`}>
                                                <RenderNumber
                                                    value={registro.variacion_drc_latex}
                                                    decimalScale={2}
                                                    suffix=" %" />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Fragment>
                }
            </div>
        )
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="form-group grid-container variacion-drc-form">
                <h6 className="mb-4">VARIACIÓN DE DRC</h6>

                {/* Pregunta si aplica */}
                <div className="formulario-fields-row">
                    <div className="formulario-field horizontal">
                        <label htmlFor="aplica_variacion_drc">¿APLICA VARIACIÓN DE DRC?</label>
                        <Field name="aplica_variacion_drc" component={renderSwitch} type="text" />
                    </div>
                </div>

                {/* Campos de variación DRC */}
                <div className="formulario-fields-row">
                    <div className="formulario-field">
                        <label htmlFor="variacion_drc_solidos" className="m-0">VARIACIÓN DRC DE SÓLIDOS</label>
                        <NumberField
                            control={control}
                            name="variacion_drc_solidos"
                            errors={errors}
                            onEnterAction={() => trigger('variacion_drc_solidos')}
                            suffix=" %"
                            rules={{
                                required: "Este campo es obligatorio",
                                min: { value: -5, message: "Debe ser mayor o igual a -5%" },
                                max: { value: 5, message: "Debe ser menor o igual a 5%" },
                            }}
                        />
                    </div>
                    <div className="formulario-field">
                        <label htmlFor="variacion_drc_latex" className="m-0">VARIACIÓN DRC DE LÁTEX</label>
                        <NumberField
                            control={control}
                            name="variacion_drc_latex"
                            errors={errors}
                            onEnterAction={() => trigger('variacion_drc_latex')}
                            suffix=" %"
                            rules={{
                                required: "Este campo es obligatorio",
                                min: { value: -5, message: "Debe ser mayor o igual a -5%" },
                                max: { value: 5, message: "Debe ser menor o igual a 5%" },
                            }}
                        />
                    </div>
                </div>

                <FieldArray name="historial_variacion_drc" component={
                    (fieldArrayProps) => renderHistorial(fieldArrayProps)
                } />

                {/* Botones */}
                <div className="buttons-box mt-3">
                    <button type="button" className="btn btn-outline-dark mx-3 mt-3 mb-2" onClick={previousStep}>ANTERIOR</button>
                    <button type="submit" className="btn btn-primary mx-3 mt-3 mb-2">GUARDAR</button>
                </div>
            </div>
        </form>
    );
};

VariacionDRCForm = reduxForm({
    form: 'fincaForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate: data => {
        return validate(data, {
            'nombre': validators.exists()('Campo requerido.'),
        })
    }
})(VariacionDRCForm);


VariacionDRCForm = connect(state => {
    const fincaForm = state.form.fincaForm;

    if (fincaForm && fincaForm.values) {
        const values = fincaForm.values;
        const { historial_variacion_drc } = values;

        return {
            historial_variacion_drc
        }
    } else {
        return {}
    }
})(VariacionDRCForm)

export default VariacionDRCForm
